import React, { Component } from 'react'

import { getPeriods, deletePeriod } from '../../services/api'

import List from '../../components-utils/List'

export default class Periods extends Component {
  render() {
    return (
      <List
        getItems={getPeriods}
        deleteItem={deletePeriod}
        path="/periods"
        elementName="période de prix"
        elementGender="f"
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/periods/Periods.js